// French for the portal-admin ladder — the eight ranked moves and the all-clear line.
import { registerFr } from '../../i18n/index.js';

registerFr({
  // 10 · portal off with a projection behind it
  'The portal is switched off, and there is a projection behind it': "Le portail est désactivé, et une projection existe derrière lui",
  '{rows} flagged published and {accounts}. With the master switch off every portal call is refused, so an invite sent today lands on a locked door.':
    "{rows} et {accounts}. Le commutateur principal étant désactivé, chaque appel au portail est refusé ; une invitation envoyée aujourd’hui atterrit devant une porte verrouillée.",
  '{n} row is': '{n} ligne est marquée publiée',
  '{n} rows are': '{n} lignes sont marquées publiées',
  '{n} account exists': '{n} compte existe',
  '{n} accounts exist': '{n} comptes existent',
  'Switch the portal on': 'Activer le portail',

  // 20 · drafts shared
  '{n} draft statement is in front of the client': '{n} déclaration en brouillon est devant le client',
  '{n} draft statements are in front of the client': '{n} déclarations en brouillon sont devant le client',
  '{refs} is still draft in the register and published to the portal. A draft statement shown to a client reads as a commitment.':
    "{refs} est encore en brouillon dans le registre et publié sur le portail. Une déclaration en brouillon montrée à un client se lit comme une promesse.",
  '{refs} are still draft in the register and published to the portal. A draft statement shown to a client reads as a commitment.':
    "{refs} sont encore en brouillon dans le registre et publiés sur le portail. Une déclaration en brouillon montrée à un client se lit comme une promesse.",
  'Stop sharing the drafts': 'Ne plus partager les brouillons',

  // 30 · nothing shared
  'Nothing is shared with {client} yet': "Rien n’est encore partagé avec {client}",
  'This engagement has {reqs} and {docs} on record, and none of them is visible to the client. The first decision is which object types the client may see at all.':
    "Ce mandat a {reqs} et {docs} au dossier, et rien de tout cela n’est visible pour le client. La première décision est de savoir quels types d’objets le client peut voir, ne serait-ce qu’en partie.",
  '{n} requirement': '{n} exigence',
  '{n} requirements': '{n} exigences',
  '{n} document': '{n} document',
  '{n} documents': '{n} documents',
  'Choose what they may see': 'Choisir ce qu’ils peuvent voir',

  // 40 · revised after publish
  '{n} published statement changed after you published it': '{n} déclaration publiée a changé après sa publication',
  '{n} published statements changed after you published them': '{n} déclarations publiées ont changé après leur publication',
  '{refs} — last publish pass {published}, current revision written {revised}. The client is reading the new text under the old decision.':
    "{refs} — dernière passe de publication {published}, révision actuelle écrite {revised}. Le client lit le nouveau texte sous l’ancienne décision.",
  'Review what changed': 'Vérifier ce qui a changé',

  // 50 · unanswered comment
  '{who} asked a question {n} day ago': '{who} a posé une question il y a {n} jour',
  '{who} asked a question {n} days ago': '{who} a posé une question il y a {n} jours',
  'A question has been waiting {n} day': 'Une question attend depuis {n} jour',
  'A question has been waiting {n} days': 'Une question attend depuis {n} jours',
  'On {subject}. Nothing has gone back.': 'Sur {subject}. Rien n’est reparti.',
  '{n} more thread is waiting behind it.': '{n} autre fil attend derrière.',
  '{n} more threads are waiting behind it.': '{n} autres fils attendent derrière.',
  'Answer it': 'Répondre',

  // 60 · view opens empty
  '{views} would open empty': "{views} s’ouvrirait vide",
  'and': 'et',
  'The object type is visible, so the tab renders in the client’s navigation, and there is nothing published behind it. An empty tab in a client portal reads as an unfinished system.':
    "Le type d’objet est visible, l’onglet apparaît donc dans la navigation du client, et rien n’est publié derrière. Un onglet vide dans un portail client se lit comme un système inachevé.",
  'Hide it or fill it': 'Le masquer ou le remplir',

  // 70 · nobody can sign in
  'The portal is on and nobody can sign in': 'Le portail est actif et personne ne peut se connecter',
  'No portal account exists for {client}. A portal account can be made from a contact already on the client record, without retyping a name or an address.':
    "Aucun compte portail n’existe pour {client}. Un compte portail peut être créé à partir d’un contact déjà présent au dossier client, sans devoir ressaisir un nom ou une adresse.",
  'Invite from contacts': 'Inviter depuis les contacts',

  // 80 · exclusions published
  '{n} exclusion is published': '{n} exclusion est publiée',
  '{n} exclusions are published': '{n} exclusions sont publiées',
  '{refs}. Showing an exclusion to a client is a contractual statement about what you are not doing — publish it only if you mean to make that point.':
    "{refs}. Montrer une exclusion à un client est une déclaration contractuelle sur ce que vous ne faites pas — ne la publiez que si c’est exactement le message que vous voulez faire passer.",
  'Check them': 'Les vérifier',

  // the all-clear
  'The projection matches the decisions on record. Nothing here needs you.': "La projection correspond aux décisions au dossier. Rien ici n’a besoin de vous.",
}, 'ladder');
